import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import PropTypes from 'prop-types';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { IDS } from '../../automationTestIds';

export const DeliveryHeader = ({
  itemId,
  quantity,
  zipCode,
  showCheckAvailability,
  setShowCheckAvailability,
  isCartTiles,
  lineItemId,
  fulfillmentMethod,
  applianceCountInCart,
  channel,
  isMajorAppliance,
  openApplianceCheckAvailability,
  showZipCodeDrawer,
}) => {
  let host = 'https://www.homedepot.com';
  if (typeof window !== 'undefined') {
    host = window.location.origin.match(/local/g)
      ? 'https://www.homedepot.com'
      : window.location.origin;
  }

  const { isConsumerApp } = useContext(ExperienceContext);

  const handleOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (isConsumerApp){
      return setShowCheckAvailability(!showCheckAvailability);
    }
    window?.LIFE_CYCLE_EVENT_BUS?.trigger('open_delivery_zip_menu');
  };

  const cartReqParams = {
    itemId,
    lineItemId,
    zipCode,
    host,
    enableNucleusDrawer: true,
    fulfillmentMethod,
    digitalDataFlag: true
  };

  const openCheckAvailability = () => {
    if (window.location.href.includes('/mycart/home')) {
      openApplianceCheckAvailability({ lineItemId, shippingType: fulfillmentMethod, channel });
    } else {
      window.LIFE_CYCLE_EVENT_BUS.trigger('cart.check-availability', {
        cartReqParams
      });
    }
  };

  const openZipDrawer = (event) => {
    event.preventDefault();
    event.stopPropagation();
    window.LIFE_CYCLE_EVENT_BUS.trigger(
      'cart.zip-code-update-click',
      {
        applianceDeliveryItems: [{
          itemId,
          quantity,
          selectedFulfillment: fulfillmentMethod,
          lineItemId,
        }],
        skipLocalization: true
      }
    );
  };

  const availabilityStencilButton = (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      classNamecomponent="span"
      onClick={handleOnClick}
      data-testid="delivery-header-zipcode-link"
    >
      { zipCode }
    </Link>
  );

  const appZipCodeButton = (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      classNamecomponent="span"
      color="primary"
      onClick={showZipCodeDrawer ? openZipDrawer : openCheckAvailability}
      data-testid="delivery-header-zipcode-link"
    >
      { zipCode }
    </Link>
  );

  const applZipCode = (applianceCountInCart === 1) ? appZipCodeButton : zipCode;

  return (
    <div
      className="sui-flex sui-w-1/2 sui-pl-2 sui-mt-auto"
      data-automation-id={IDS.LABEL.deliveryToLabel}
    >
      <Typography variant="body-base" height="normal">
        {'Delivering to '}
        <span className="sui-cursor-pointer">{ isCartTiles
          && isMajorAppliance ? applZipCode : availabilityStencilButton }
        </span>
      </Typography>
    </div>
  );
};

DeliveryHeader.propTypes = {
  itemId: PropTypes.string.isRequired,
  showZipCodeDrawer: PropTypes.bool,
  lineItemId: PropTypes.string,
  zipCode: PropTypes.string.isRequired,
  showCheckAvailability: PropTypes.bool.isRequired,
  setShowCheckAvailability: PropTypes.func.isRequired,
  isCartTiles: PropTypes.bool,
  applianceCountInCart: PropTypes.number,
  channel: PropTypes.string.isRequired,
  quantity: PropTypes.number,
  fulfillmentMethod: PropTypes.string.isRequired,
  isMajorAppliance: PropTypes.bool.isRequired,
  openApplianceCheckAvailability: PropTypes.func.isRequired
};

DeliveryHeader.defaultProps = {
  showZipCodeDrawer: false,
  lineItemId: '',
  isCartTiles: false,
  applianceCountInCart: 0,
  quantity: 0,
};
